<template>
  <div class="title-bar">
    {{ title }}
  </div>
</template>

<script>
export default {
  name: 'TitleBar',

  props: {
    title: {
      type: String,
      default: '',
    },
  },
};
</script>

<style lang="less" scoped>
.title-bar {
  display: flex;
  align-items: center;
  justify-content: center;
  width: fit-content;
  height: 20px;
  padding: 0px 8px;
  color: #fff;
  font-size: 13px;
  font-weight: 400;
  line-height: normal;
  background-color: #365aa4;
  border-radius: 10px 10px 10px 0;
}
</style>
